import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { Box } from '@chakra-ui/react';

/**
 * Wraps children in a fade+rise scroll reveal animation.
 * Respects prefers-reduced-motion.
 */
export function ScrollReveal({ children, delay = 0, once = true, ...props }) {
  const prefersReduced = useReducedMotion();

  if (prefersReduced) {
    return <Box {...props}>{children}</Box>;
  }

  return (
    <Box
      as={motion.div}
      initial={{ opacity: 0, y: 80 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: '-80px' }}
      transition={{ duration: 0.6, ease: 'easeOut', delay }}
      {...props}
    >
      {children}
    </Box>
  );
}